import axios from "axios";

const instance = axios.create({
  baseURL: "https://talker8.herokuapp.com/",
});
export default instance;
